import React, { useState, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function PDFViewer({ url, name, compact = false }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(300);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  }, []);

  const goNext = (e) => {
    e.stopPropagation();
    if (pageNumber < numPages) setPageNumber(prev => prev + 1);
  };

  const goPrev = (e) => {
    e.stopPropagation();
    if (pageNumber > 1) setPageNumber(prev => prev - 1);
  };

  return (
    <div ref={containerRef} className="relative bg-gray-100 rounded-lg overflow-hidden">
      <Document
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div className="flex items-center justify-center h-48 text-gray-400 text-sm">Loading PDF...</div>}
        error={<div className="flex items-center justify-center h-48 text-gray-400 text-sm">Failed to load PDF</div>}
      >
        <Page
          pageNumber={pageNumber}
          width={containerWidth}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>

      {numPages > 1 && (
        <>
          {pageNumber > 1 && (
            <button
              onClick={goPrev}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white rounded-full w-9 h-9 md:w-7 md:h-7 flex items-center justify-center hover:bg-black/70 text-sm"
            >
              ◀
            </button>
          )}
          {pageNumber < numPages && (
            <button
              onClick={goNext}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white rounded-full w-9 h-9 md:w-7 md:h-7 flex items-center justify-center hover:bg-black/70 text-sm"
            >
              ▶
            </button>
          )}
        </>
      )}

      {numPages && (
        <div className="absolute bottom-1 left-1/2 -translate-x-1/2 bg-black/60 text-white text-xs px-2 py-0.5 rounded-full">
          {pageNumber} / {numPages}
        </div>
      )}

      {!compact && (
        <div className="flex items-center justify-between px-3 py-2 bg-gray-50 border-t text-sm">
          <span className="truncate text-gray-600">📄 {name}</span>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:text-blue-700 whitespace-nowrap ml-2"
            onClick={(e) => e.stopPropagation()}
          >
            Download ⬇
          </a>
        </div>
      )}
    </div>
  );
}

export default PDFViewer;
